export default "__VITE_ASSET__BB9wx4GF__"